

const processError = require('./error-process');

module.exports = (space, type, data) => {
  if (data.overwriteKeys) {
    delete data.overwriteKeys;
  }

  return space.createEntry(type, data).catch(
    processError
  );
};
